<template>
  <!--购买课程-->
  <div class="box">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="top-box">
          <div
            class
            style="display:flex;border-radius:5px;border:1px solid #00B388;width:3.3rem;margin:10px auto;overflow: hidden"
          >
            <div
              class="top-left"
              @click="onBrowse"
              :style="active ==1 ? 'background: #00B388;color: #fff;':'background: #fff;color: #00B388;'"
            >浏览历史</div>
            <div
              class="top-right"
              @click="onBuy"
              :style="active==2 ? 'background: #00B388;color: #fff;':'background: #fff;color: #00B388;'"
            >已购买</div>
          </div>
        </div>
        
        <div style="width:7.1rem;margin:0 auto">
          <div v-for="(item,i) in courseList" :key="i" class="course-items" v-rblink= "{name:'CourseDetail',query:{id:item.course_id}}">
            <img :src="item.pic_url" alt="">
            <div class="course-info">
              <p class="p1">{{item.title}}</p>
              <p class="p2">{{item.times}}</p>
              <p class="p3">{{item.pay_price}}</p>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<style scoped>
.p1{
height: 40px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #000000;
line-height: 20px;
display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-top: 5px;
}
.p2{
height: 15px;
font-size: 11px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #999999;
line-height: 15px;
}
.p3{
height: 20px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FF4768;
line-height: 20px;
margin-top: 5px;

}
.course-items .course-info{
  flex: 1;
}
.course-items{
  display: flex;
  justify-content:space-between;
  margin-top: 20px;
  padding: 10px;
  background: #ffffff;
  border-radius: 10px;
}
.course-items img{
  width: 3rem;
height: 1.8rem;
/* background: #F1F1F1; */
border-radius: 5px;
 object-fit: cover;
 margin-right: 10px;
}
.top-left,
.top-right {
  width: 1.65rem;
  height: 0.5rem;

  line-height: 0.5rem;
  text-align: center;
}
.top-box {
  width: 100%;
  height: 1rem;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box {
  /*margin-bottom: 1.5rem;*/
  background: #f8f8f8;
  height: 100%;
}
.box >>> .van-tabs__line {
  background: #00b388;
}
</style>
<script>
import Vue from "vue";
import { Toast, Cell, CellGroup } from "vant";
import LoginDialog from "@/components/LoginDialog.vue";
import PayDialog from "@/components/PayDialog.vue";

Vue.use(Toast)
  .use(Cell)
  .use(CellGroup);
export default {
  name: "MyCourseList",
  components: { LoginDialog, PayDialog },
  data: function() {
    return {
      active: 0,
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        pageNo: 1
      },
      courseList:[],
      browseIds:[]
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "我的课程";
    that.active=localStorage.getItem('active')
    if(that.active==2){
      that.getCourseList()
    }else{
      that.onBrowse()
    }
  },
  watch: {},
  destroyed() {},
  methods: {
    onBrowse() {
      let that=this
      this.active = 1;
      localStorage.setItem('active',1)
      that.courseList=[]
      let arr = JSON.parse(localStorage.getItem("browseIds"));
      console.log(arr);
      that.browseIds=arr
      that.params.pageNo=1
      that.getBrowseList()
    },
    onBuy() {
      let that=this
      this.active = 2;
      localStorage.setItem('active',2)
      that.courseList=[]
      that.params.pageNo=1
      that.getCourseList()
    },
    getBrowseList(){
      let that=this
      this.$api.get(
        "/api/course/myBrowseCourseList",
        {browseIds:that.browseIds,pageNo:that.params.pageNo},
        res => {
          that.loading = false;
          if (res.data.currentpage == 1) {
            that.isLoading = false;
            that.courseList = res.data.list;
          } else {
            that.courseList = that.courseList.concat(res.data.list);
          }
          if (res.data.list.length == 0) {
            that.finished = true;
          }
          that.params.pageNo += 1;
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    getCourseList(){
      let that=this
      this.$api.get(
        "/api/course/myBuyCourseList",
        this.params,
        res => {
          that.loading = false;
          if (res.data.currentpage == 1) {
            that.isLoading = false;
            that.courseList = res.data.list;
          } else {
            that.courseList = that.courseList.concat(res.data.list);
          }
          if (res.data.list.length == 0) {
            that.finished = true;
          }
          that.params.pageNo += 1;
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      if(that.active==1){
        that.getBrowseList()
      }else{
        that.getCourseList();
      }
      // console.log('2342')
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      let that=this
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          if(that.active==1){
        that.getBrowseList()
      }else{
        that.getCourseList();
      }
        }, 500);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// MyCourseList.vue?75976db8